<template>
	<div class="addPosition">
		<el-container>
			<el-header class="management_header">
				<div class="nidrlogo">
					<img src="../../image/zsdb_logo.png" />
				</div>
				<div class="accoutInfo">
					<span class="headerText">尊敬的管理员{{showID}}，您好！</span>
					<span class="divider">|</span>
					<el-link type="primary" class="headerText" @click="addControl()">+新增管理员</el-link>
					<span class="divider">|</span>
					<el-link type="primary" @click="exit()" class="headerText">退出</el-link>
				</div>
			</el-header>
			<el-container>
				<el-aside class="management_aside">
					<el-menu default-active="4" class="personalmenu" background-color="#545c64" text-color="#fff"
						active-text-color="#ffd04b">
						<el-menu-item index="1" @click="gotoadd()">
							<span class="menuText" slot="title">新增岗位</span>
						</el-menu-item>
						<el-menu-item index="2" @click="gotoreset()">
							<span class="menuText" slot="title">查询/修改岗位信息</span>
						</el-menu-item>
						<el-submenu index="3">
							<template slot="title">
								<span class="menuText">查看简历</span>
							</template>
							<el-menu-item-group>
								<el-menu-item index="3-1" @click="gotolookupresumeByName()">按人名查找</el-menu-item>
								<el-menu-item index="3-2" @click="gotolookupresume()">按时间、岗位查找</el-menu-item>
							</el-menu-item-group>
						</el-submenu>
						<el-menu-item index="4">
							<span class="menuText" slot="title">招聘公告维护</span>
						</el-menu-item>
					</el-menu>
				</el-aside>
				<el-main class="management_body">
					<addControl v-show="addControlDialog" v-on:addAdmingAccount='addAdmingAccount'></addControl>
					<div class="service_body">
						<el-page-header class="go_back" @back="goBack" content="">
						</el-page-header>
						<div class="arctict_title" style="display: flex;">
							<el-form ref="form" label-width="80px" style="width: 80%;">
								<el-form-item label="发布时间">
									<el-date-picker v-model="publishTime" align="right" type="date" format="yyyy-MM-dd"
										value-format="timestamp">
									</el-date-picker>
								</el-form-item>
								<el-form-item label="公告标题">
									<el-input v-model="arctictName" style="width: 100%;"></el-input>
								</el-form-item>
							</el-form>
						</div>
						<wang-editor ref="wangEditor" class="wangcontent" v-model="content"></wang-editor>
						<div class="info_release_button">
							<el-button type="primary" round @click="releaseInfo()">保 存</el-button>
						</div>
						<div class="upload_annex">
							<el-upload class="upload-demo" ref="uploadAnnex" action="annexURL" :auto-upload="false"
								:with-credentials="true" :show-file-list="false" :on-change="uploadAnnex">
								<el-button size="small" type="success">
									上传文件</el-button>
							</el-upload>
						</div>
						<div class="annex_list" v-if="annexList.length != 0">
							<el-table :data="annexList" style="width: 100%">
								<el-table-column prop="fileName" label="名字">
								</el-table-column>
								<el-table-column fixed="right" label="操作" width="150">
									<template slot-scope="scope">
										<el-button @click="downloadAnnex(scope.row)" type="text" size="small">下载
										</el-button>
										<el-button @click="deleteAnnex(scope.row)" type="text" size="small">删除
										</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<div class="footer">
			<div class="container">
				<p>&copy 2022 Inc. All Rights Reserved. 中水东北勘测设计研究有限责任公司 版权所有 吉ICP备2022003947号-1
					技术支持：中水东北勘测设计研究有限责任公司数字与智慧工程院
					<br />吉公网安备 22010402001082号
				</p>
			</div>
		</div>
	</div>
</template>

<script>
	import addControl from "../../components/addControl.vue"
	import {
		loginstatus,
		Logout,
		addAdminUser,
		addPosition,
		uploadArticleFile,
		queryFileListOfArticle,
		deleteFileOfArticle,
		optArticle,
		queryArticle,
	} from '../../api/user.js';
	import WangEditor from "@/components/weditor"
	export default {
		components: {
			addControl,
			WangEditor
		},
		data() {
			return {
				annexList: [],
				addControlDialog: false,
				userID: '',
				showID: '',
				annexURL: '',
				content: null,
				rowInfo: {},
				arctictName: '',
				publishTime: '',
			}
		},
		mounted() {
			this.rowInfo = this.$route.query.row
			loginstatus().then((res) => {
				if (res.code == 300) {
					let str = res.data;
					this.showID = str.substring(0, 3) + '****' + str.substring(7, 11);
					this.userID = res.datadata
				} else {
					this.$message({
						message: '您不具有管理员权限！',
						type: 'error'
					});
					this.$router.push('/')
				}
			});
			queryArticle({
				articleName: this.rowInfo.articleName,
			}).then((res) => {
				if (res.code == 200) {
					this.content = res.data.articleValue
					this.arctictName = res.data.articleTitle
					this.publishTime = res.data.articleUpdateTime
				} else {
					this.$router.push('/management/arcticList')
				}
			});
			queryFileListOfArticle({
				articleName: this.rowInfo.articleName
			}).then((res) => {
				this.annexList = res.data
			});
		},
		methods: {
			releaseInfo() {
				this.content = this.$refs.wangEditor.getContent();
				optArticle({
					articleName: this.rowInfo.articleName,
					articleTitle: this.arctictName,
					articleValue: this.content,
					articleStatus: this.rowInfo.articleStatus,
					articleUpdateTime: this.publishTime,
				}).then((res) => {
					if (res.code == 200) {
						this.$message({
							message: '公告保存成功！',
							type: 'success'
						});
					}
				})
			},
			goBack() {
				this.$router.push('/management/arcticList')
			},
			downloadAnnex(row) {
				var baseUrl;
				baseUrl = row.fileLink
				window.open(baseUrl, '_blank')
			},
			deleteAnnex(row) {
				deleteFileOfArticle({
					articleName: this.rowInfo.articleName,
					fileName: row.fileName,
					fileType: row.fileType
				}).then((res) => {
					if (res.code == 200) {
						this.$message({
							message: '附件删除成功！',
							type: 'success'
						});
						queryFileListOfArticle({
							articleName: this.rowInfo.articleName
						}).then((res1) => {
							this.annexList = res1.data
						});
					} else {
						this.$message({
							message: '附件删除失败！',
							type: 'error'
						});
					}
				})
			},
			uploadAnnex() {
				var that = this
				var file = this.$refs.uploadAnnex.uploadFiles
				let i = 0
				i = file.length - 1
				let formData = new window.FormData();
				formData.append('file', file[i].raw);
				uploadArticleFile(this.rowInfo.articleName, file[i].raw).then((res) => {
					queryFileListOfArticle({
						articleName: this.rowInfo.articleName
					}).then((res1) => {
						this.annexList = res1.data
					});
				})
			},
			addAdmingAccount(addAdmingAccount) {
				addAdminUser({
					password: addAdmingAccount.adminPassword,
					userID: addAdmingAccount.adminAccount,
				}).then((res) => {
					if (res.code == 200) {
						this.$message({
							message: '管理员账号添加成功！',
							type: 'success'
						});
						this.addControlDialog = false
					} else {
						this.$message({
							message: '管理员账号添加失败！',
							type: 'error'
						});
						this.addControlDialog = false
					}
				})
			},
			addControl() {
				this.addControlDialog = true
			},
			exit() {
				Logout().then((res) => {
					this.$router.push('/')
				})
			},
			gotoadd() {
				this.$router.push('/management/addPosition')
			},
			gotolookupresumeByName() {
				this.$router.push('/management/lookUpResumeByName')
			},
			gotoreset() {
				this.$router.push('/management/resetPosition')
			},
			gotolookupresume() {
				this.$router.push('/management/lookUpResume')
			},
		},
	};
</script>

<style lang="scss">
	@import url(../../assets/css/managementcss.css);

	.go_back {
		margin-top: 15px;
		margin-left: 15px;
	}

	.service_body {
		box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
		border-radius: 4px;
		width: 80%;
		margin-left: 10%;
		margin-top: 35px;
		padding-bottom: 35px;
		padding-top: 10px;
	}

	.addPosition_title {
		font-size: 26px;
		font-weight: bold;
		margin-left: 40%;
		padding-top: 25px;
	}

	.addPosition_info {
		width: 80%;
		margin-left: 10%;
		margin-top: 35px;
		padding-top: 25px;
	}

	.ruleForm_info {
		width: 510px;
	}

	.add_button_area {
		margin-left: 34%;
		margin-top: 55px;
	}

	.editor {
		line-height: normal !important;
	}

	.upload_annex {
		margin-top: 35px;
		margin-left: 45%;
	}

	.info_release_button {
		margin-left: 45%;
		margin-top: 35px;
	}

	.annex_list {
		width: 80%;
		margin-left: 10%;
		margin-top: 15px;
	}

	.arctict_title {
		padding-top: 35px;
	}
</style>
